var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"anx-readonly",on:{"click":_vm.click}},[_c('div',{class:'inner-text ' + (_vm.bold !== null ? 'bold ' : '')},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }